import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './humanTeam.module.scss';
import efficiencyHumanTeamNoData from '../../../assets/efficiencyHumanTeamNoData.svg';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface HumanTeamProps { }

/* eslint-disable @typescript-eslint/no-non-null-assertion */
const HumanTeam: FC<HumanTeamProps> = () => {
  const [t] = useTranslation();

  return (
    <div data-testid='humanTeam-test' id='humanteam-nodata' className={styles.noData}>
      <img src={efficiencyHumanTeamNoData} />
      <p>{t('details.humanTeam.noData')}</p>
      <div className='footer' style={{marginBottom: '75px'}}></div>
    </div>
  );
};

export default HumanTeam;
